import { DsAlert as e, DsBadge as t, DsButton as n, DsCard as r, DsDialog as i, DsLink as a, DsSwitch as o, DsTabBar as s, DsTabBarItem as c, dsToast as l } from "@frontends/ds";
import { formatDateTime as u, personDetail as d, personName as f } from "@frontends/util-spg-format";
import { useTranslation as p } from "react-i18next";
import { Fragment as m, jsx as h, jsxs as g } from "react/jsx-runtime";
import { ALL_INSTANCES as _, useCreateRetentionRuleMutation as v, useDeleteRetentionRuleMutation as y, useDryRunRetentionRuleMutation as b, useRetentionHealthQuery as x, useRetentionRuleQuery as S, useRetentionRulesQuery as C, useRuleRunsQuery as w, useSetRetentionRuleEnabledMutation as T, useUpdateRetentionRuleMutation as E } from "@frontends/data-access-spg-retention-rules";
import { Page as D, PageHeader as O, PropertyList as k } from "@frontends/ui-spg-layout";
import { useLocation as ee, useNavigate as A, useParams as te, useSearchParams as j } from "react-router";
import { useAllInstancesQuery as M } from "@frontends/data-access-spg-instances";
import { useForm as ne } from "@frontends/form";
import { useSelector as re } from "@tanstack/react-form";
import { useRef as ie, useState as N } from "react";
import { parseDate as ae } from "@internationalized/date";
import { getApiErrorMessage as P } from "@frontends/util-api-errors";
import { DecisionsTable as oe } from "@frontends/feature-spg-decisions";
import { UiKitAlertDialog as se } from "@frontends/ui-kit";
import { useDataTable as ce } from "@frontends/data-table";
import { formatDuration as le } from "date-fns";
//#region src/lib/constants.ts
var F = "feature-spg-retention-rules", ue = [
	"trade_volume",
	"trade_count",
	"trade_recency",
	"balance"
], de = [
	"sliding",
	"calendar",
	"cycle"
], fe = [
	"day",
	"week",
	"month"
], pe = [
	"remove",
	"suspend",
	"block"
], me = [
	"write_once",
	"always",
	"on_removal"
], he = ["skip", "judge"], I = [
	"minutes",
	"hours",
	"days"
], L = {
	minutes: 60,
	hours: 3600,
	days: 86400
}, R = L.days;
//#endregion
//#region src/lib/components/Health.tsx
function z(e) {
	return e.lastRun?.status === "aborted";
}
function ge(e) {
	return z(e) || e.unsanctioned > 0 || e.stuck > 0;
}
function _e({ items: e }) {
	let { t: n } = p(F), r = e.filter(z).length, i = e.reduce((e, t) => e + t.unsanctioned, 0), a = e.reduce((e, t) => e + t.stuck, 0);
	return e.length === 0 ? /* @__PURE__ */ h("span", {
		className: "text-textTertiary",
		children: n("health.noRules")
	}) : !r && !i && !a ? /* @__PURE__ */ h(t, {
		size: "sm",
		variant: "success",
		children: n("health.ok")
	}) : /* @__PURE__ */ g("div", {
		className: "flex flex-wrap gap-1",
		children: [
			r > 0 && /* @__PURE__ */ h(t, {
				size: "sm",
				variant: "danger",
				children: n("health.badges.aborted", { count: r })
			}),
			i > 0 && /* @__PURE__ */ h(t, {
				size: "sm",
				variant: "danger",
				children: n("health.badges.unsanctioned", { count: i })
			}),
			a > 0 && /* @__PURE__ */ h(t, {
				size: "sm",
				variant: "warning",
				children: n("health.badges.stuck", { count: a })
			})
		]
	});
}
function ve({ items: t, rules: n }) {
	let { t: r } = p(F), i = t.filter(ge);
	return i.length === 0 ? null : /* @__PURE__ */ h("div", {
		className: "flex flex-col gap-3",
		children: i.map((t) => /* @__PURE__ */ g("div", {
			className: "flex flex-col gap-2",
			children: [
				n && /* @__PURE__ */ h(a, {
					href: n.getHref(t.ruleId),
					className: "self-start text-base font-medium",
					children: n.names.get(t.ruleId) ?? r("unknown")
				}),
				z(t) && t.lastRun && /* @__PURE__ */ h(e, {
					variant: "danger",
					title: r("health.alerts.aborted.title", { firedAt: u(t.lastRun.firedAt) }),
					description: r("health.alerts.aborted.description", { reason: t.lastRun.abortReason })
				}),
				t.unsanctioned > 0 && /* @__PURE__ */ h(e, {
					variant: "danger",
					title: r("health.alerts.unsanctioned.title", { count: t.unsanctioned }),
					description: r("health.alerts.unsanctioned.description")
				}),
				t.stuck > 0 && /* @__PURE__ */ h(e, {
					variant: "warning",
					title: r("health.alerts.stuck.title", { count: t.stuck }),
					description: r("health.alerts.stuck.description")
				})
			]
		}, t.ruleId))
	});
}
//#endregion
//#region src/lib/form/values.ts
function B(e) {
	return String(e ?? "").trim();
}
function V(e) {
	return typeof e == "number" && !Number.isNaN(e) ? e : 0;
}
function H(e, t) {
	let n = I.includes(t) ? t : "days";
	return Math.round(V(e) * L[n]);
}
function ye(e) {
	let t = [...I].reverse().find((t) => e > 0 && e % L[t] === 0);
	return t ? {
		unit: t,
		value: e / L[t]
	} : {
		unit: "days",
		value: 0
	};
}
//#endregion
//#region src/lib/form/periodFields.ts
function be(e, t) {
	return {
		[`${e}Model`]: {
			type: "radio",
			label: t("form.period.model"),
			defaultValue: "calendar",
			options: de.map((e) => ({
				value: e,
				label: t(`periodModels.${e}`)
			})),
			props: { orientation: "horizontal" }
		},
		[`${e}AlignTo`]: {
			type: "select",
			label: t("form.period.alignTo"),
			defaultValue: "week",
			options: fe.map((e) => ({
				value: e,
				label: t(`calendarUnits.${e}`)
			}))
		},
		[`${e}LengthDays`]: {
			type: "number",
			label: t("form.period.lengthDays"),
			defaultValue: 30
		},
		[`${e}DuePosition`]: {
			type: "number",
			label: t("form.period.duePosition"),
			description: t("form.hints.duePosition"),
			defaultValue: 0
		},
		[`${e}DueWindowDays`]: {
			type: "number",
			label: t("form.period.dueWindowDays"),
			description: t("form.hints.dueWindow"),
			defaultValue: 3
		},
		[`${e}StartsAt`]: {
			type: "date",
			label: t("form.period.startsAt"),
			description: t("form.hints.startsAt")
		}
	};
}
function xe(e, t) {
	return {
		[`${e}.model`]: `${t}Model`,
		[`${e}.align_to`]: `${t}AlignTo`,
		[`${e}.length_seconds`]: `${t}LengthDays`,
		[`${e}.due_position`]: `${t}DuePosition`,
		[`${e}.due_window_seconds`]: `${t}DueWindowDays`,
		[`${e}.starts_at`]: `${t}StartsAt`
	};
}
function Se(e, t) {
	let n = e[`${t}Model`], r = e[`${t}StartsAt`];
	return {
		model: n,
		alignTo: n === "calendar" ? B(e[`${t}AlignTo`]) : "",
		lengthSeconds: n === "calendar" ? 0 : V(e[`${t}LengthDays`]) * R,
		duePosition: n === "cycle" ? V(e[`${t}DuePosition`]) : 0,
		dueWindowSeconds: n === "cycle" ? V(e[`${t}DueWindowDays`]) * R : 0,
		startsAt: n === "cycle" && r ? `${String(r)}T00:00:00Z` : null
	};
}
function Ce(e, t) {
	return {
		[`${t}Model`]: e.model,
		...e.alignTo ? { [`${t}AlignTo`]: e.alignTo } : {},
		...e.lengthSeconds ? { [`${t}LengthDays`]: e.lengthSeconds / R } : {},
		[`${t}DuePosition`]: e.duePosition,
		...e.dueWindowSeconds ? { [`${t}DueWindowDays`]: e.dueWindowSeconds / R } : {},
		...e.startsAt ? { [`${t}StartsAt`]: ae(e.startsAt.slice(0, 10)) } : {}
	};
}
//#endregion
//#region src/lib/components/DryRunDialog.tsx
var U = [
	"sanction",
	"warn",
	"clear",
	"held",
	"given_up"
], we = {
	sanction: "danger",
	warn: "warning",
	clear: "success",
	held: "neutral",
	given_up: "neutral"
};
function Te({ report: t, checkedAt: n, onClose: r }) {
	let { t: a } = p(F), o = t.sanction.verdicts.filter((e) => e.action === "sanction").length;
	return /* @__PURE__ */ h(i, {
		title: a("dryRun.title"),
		size: "lg",
		isOpen: !0,
		onOpenChange: (e) => !e && r(),
		children: /* @__PURE__ */ g("div", {
			className: "flex flex-col gap-6",
			children: [
				/* @__PURE__ */ h("p", { children: a("dryRun.description", { checkedAt: u(n) }) }),
				/* @__PURE__ */ h(Ee, {
					stage: t.sanction,
					title: a("runs.stages.kick")
				}),
				o > t.sanctionsToApply && /* @__PURE__ */ h(e, {
					variant: "info",
					title: a("dryRun.capped", {
						count: o,
						applied: t.sanctionsToApply
					})
				}),
				t.warning && /* @__PURE__ */ h(Ee, {
					stage: t.warning,
					title: a("runs.stages.warn")
				})
			]
		})
	});
}
function Ee({ stage: n, title: r }) {
	let { t: i } = p(F), a = [...n.verdicts].sort((e, t) => U.indexOf(e.action) - U.indexOf(t.action));
	return /* @__PURE__ */ g("section", {
		className: "flex flex-col gap-3",
		children: [
			/* @__PURE__ */ g("div", {
				className: "flex flex-col gap-1",
				children: [/* @__PURE__ */ h("h3", {
					className: "font-medium text-textPrimary",
					children: r
				}), /* @__PURE__ */ h("p", {
					className: "text-sm",
					children: i("dryRun.summary", {
						cohort: n.cohort,
						measured: n.measured
					})
				})]
			}),
			n.abortReason && /* @__PURE__ */ h(e, {
				variant: "danger",
				title: i("dryRun.aborted"),
				description: n.abortReason
			}),
			!n.abortReason && a.length === 0 && /* @__PURE__ */ h("p", { children: i("dryRun.nobody") }),
			!n.abortReason && a.length > 0 && /* @__PURE__ */ g(m, { children: [/* @__PURE__ */ h("div", {
				className: "flex flex-wrap gap-2",
				children: U.map((e) => {
					let n = a.filter((t) => t.action === e).length;
					return n > 0 ? /* @__PURE__ */ h(t, {
						size: "md",
						variant: we[e],
						children: i(`dryRun.counts.${e}`, { count: n })
					}, e) : null;
				})
			}), /* @__PURE__ */ h("ul", {
				className: "flex flex-col divide-y divide-borderSurface",
				children: a.map((e) => /* @__PURE__ */ h(De, { verdict: e }, e.participationId))
			})] })
		]
	});
}
function De({ verdict: e }) {
	let { t: n } = p(F);
	return /* @__PURE__ */ g("li", {
		className: "flex items-start justify-between gap-4 py-2",
		children: [/* @__PURE__ */ g("div", {
			className: "flex min-w-0 flex-col",
			children: [
				/* @__PURE__ */ h("span", {
					className: "truncate text-textPrimary",
					children: f(e.person)
				}),
				/* @__PURE__ */ h("span", {
					className: "truncate text-sm",
					children: d(e.person)
				}),
				/* @__PURE__ */ g("span", {
					className: "text-sm",
					children: [
						u(e.windowFrom),
						" – ",
						u(e.windowTo)
					]
				})
			]
		}), /* @__PURE__ */ g("div", {
			className: "flex shrink-0 flex-col items-end gap-1",
			children: [
				/* @__PURE__ */ h(t, {
					size: "sm",
					variant: we[e.action],
					children: n(`dryRun.actions.${e.action}`)
				}),
				/* @__PURE__ */ h("span", {
					className: "text-sm",
					children: n("dryRun.figures", {
						measured: String(e.evidence.measured ?? "—"),
						required: String(e.evidence.required ?? "—")
					})
				}),
				e.givenUpReason && /* @__PURE__ */ h("span", {
					className: "text-sm",
					children: e.givenUpReason
				})
			]
		})]
	});
}
//#endregion
//#region src/lib/components/PeriodFieldset.tsx
function Oe({ Field: e, model: t, prefix: n }) {
	return /* @__PURE__ */ g("div", {
		className: "flex flex-col gap-4",
		children: [
			/* @__PURE__ */ h(e, { name: `${n}Model` }),
			t === "calendar" && /* @__PURE__ */ h(e, { name: `${n}AlignTo` }),
			t !== "calendar" && /* @__PURE__ */ g("div", {
				className: "grid gap-4 sm:grid-cols-2",
				children: [
					/* @__PURE__ */ h(e, { name: `${n}LengthDays` }),
					t === "cycle" && /* @__PURE__ */ h(e, { name: `${n}DuePosition` }),
					t === "cycle" && /* @__PURE__ */ h(e, { name: `${n}DueWindowDays` }),
					t === "cycle" && /* @__PURE__ */ h(e, { name: `${n}StartsAt` })
				]
			})
		]
	});
}
//#endregion
//#region src/lib/components/RetentionRuleForm.tsx
var W = "custom", G = {
	daily: "0 3 * * *",
	weekly: "0 3 * * 1",
	monthly: "0 3 1 * *"
}, K = {
	daily: "0 3 * * *",
	thursday: "0 3 * * 4"
}, ke = {
	instance_id: "instanceId",
	"measurement.metric": "metric",
	"measurement.threshold": "threshold",
	"measurement.instruments": "instruments",
	...xe("period", "period"),
	schedule: "schedulePreset",
	"warning.schedule": "warningPreset",
	"warning.period": "warningOwnPeriod",
	...xe("warning.period", "warningPeriod"),
	grace_seconds: "graceValue",
	settling_seconds: "settlingValue",
	anchor_policy: "anchorPolicy",
	missing_anchor: "missingAnchor",
	"sanction.kind": "sanctionKind",
	"sanction.duration_seconds": "suspendValue",
	min_coverage: "minCoveragePercent",
	min_cohort: "minCohort",
	max_per_run: "maxPerRun"
};
function Ae(e, t, n, r) {
	let i = B(e[t]);
	return i === W ? B(e[n]) : r[i] ?? "";
}
function je(e) {
	let t = e.metric, n = e.mode, r = e.sanctionKind, i = n === "with_warning" && e.warningEnabled === !0, a = B(e.instruments).split(",").map((e) => e.trim()).filter(Boolean);
	return {
		instanceId: B(e.instanceId),
		name: B(e.name),
		enabled: !0,
		measurement: {
			metric: t,
			threshold: t === "trade_recency" ? 0 : V(e.threshold),
			instruments: t !== "balance" && a.length > 0 ? a : void 0
		},
		period: Se(e, "period"),
		schedule: Ae(e, "schedulePreset", "scheduleCustom", G),
		warning: {
			schedule: i ? Ae(e, "warningPreset", "warningCustom", K) : "",
			period: i && e.warningOwnPeriod === !0 ? Se(e, "warningPeriod") : null
		},
		mode: n,
		graceSeconds: n === "with_warning" ? H(e.graceValue, e.graceUnit) : 0,
		settlingSeconds: H(e.settlingValue, e.settlingUnit),
		anchorPolicy: e.anchorPolicy,
		missingAnchor: e.missingAnchor,
		sanction: {
			kind: r,
			durationSeconds: r === "suspend" ? H(e.suspendValue, e.suspendUnit) : 0
		},
		priority: V(e.priority),
		minCoverage: V(e.minCoveragePercent) / 100,
		minCohort: V(e.minCohort),
		maxPerRun: V(e.maxPerRun)
	};
}
function Me(e, t, n, r) {
	let i = Object.entries(t).find(([, t]) => t === e)?.[0];
	return i ? { [n]: i } : {
		[n]: W,
		[r]: e
	};
}
function q(e, t, n) {
	let r = ye(e);
	return {
		[t]: r.value,
		[n]: r.unit
	};
}
function Ne(e) {
	let { measurement: t } = e;
	return {
		instanceId: e.instanceId,
		name: e.name,
		priority: e.priority,
		metric: t.metric,
		threshold: t.threshold,
		instruments: t.instruments?.join(", ") ?? "",
		...Ce(e.period, "period"),
		...Me(e.schedule, G, "schedulePreset", "scheduleCustom"),
		mode: e.mode,
		...e.mode === "with_warning" ? q(e.graceSeconds, "graceValue", "graceUnit") : {},
		warningEnabled: e.warning.schedule !== "",
		...e.warning.schedule ? Me(e.warning.schedule, K, "warningPreset", "warningCustom") : {},
		warningOwnPeriod: e.warning.period !== null,
		...e.warning.period ? Ce(e.warning.period, "warningPeriod") : {},
		sanctionKind: e.sanction.kind,
		...e.sanction.kind === "suspend" ? q(e.sanction.durationSeconds, "suspendValue", "suspendUnit") : {},
		anchorPolicy: e.anchorPolicy,
		...q(e.settlingSeconds, "settlingValue", "settlingUnit"),
		missingAnchor: e.missingAnchor,
		minCoveragePercent: Math.round(e.minCoverage * 100),
		minCohort: e.minCohort,
		maxPerRun: e.maxPerRun
	};
}
function Pe(e, t) {
	return Object.fromEntries(Object.entries(e).map(([e, n]) => [e, e in t ? {
		...n,
		defaultValue: t[e]
	} : n]));
}
function J(e, t) {
	return re(e.store, (e) => e.values[t]);
}
function Fe({ initial: e, instanceId: t = null, notice: r, submitLabel: i, onCheck: a, onSubmit: o }) {
	let { t: s } = p(F), c = M().data ?? [], [l, u] = N(null), [d, f] = N(!1), _ = ie("save"), v = I.map((e) => ({
		value: e,
		label: s(`unitNames.${e}`)
	})), y = (e) => [...Object.keys(e).map((e) => ({
		value: e,
		label: s(`form.presets.${e}`)
	})), {
		value: W,
		label: s("form.presets.custom")
	}], b = ne({
		fields: Pe({
			instanceId: {
				type: "select",
				label: s("fields.instance"),
				defaultValue: t,
				options: c.map((e) => ({
					value: e.id,
					label: e.name
				})),
				validators: ["required"]
			},
			name: {
				type: "text",
				label: s("form.name"),
				validators: ["required"]
			},
			priority: {
				type: "number",
				label: s("fields.priority"),
				description: s("form.hints.priority"),
				defaultValue: 0
			},
			metric: {
				type: "select",
				label: s("fields.measurement"),
				defaultValue: "trade_volume",
				options: ue.map((e) => ({
					value: e,
					label: s(`metrics.${e}`)
				}))
			},
			threshold: {
				type: "number",
				label: s("form.threshold"),
				defaultValue: 1
			},
			instruments: {
				type: "text",
				label: s("form.instruments"),
				description: s("form.hints.instruments")
			},
			...be("period", s),
			schedulePreset: {
				type: "select",
				label: s("fields.schedule"),
				description: s("form.hints.schedule"),
				defaultValue: "weekly",
				options: y(G)
			},
			scheduleCustom: {
				type: "text",
				label: s("form.cron"),
				placeholder: "0 3 * * 1",
				description: s("form.hints.cron")
			},
			mode: {
				type: "radio",
				label: s("fields.mode"),
				defaultValue: "with_warning",
				options: ["with_warning", "immediate"].map((e) => ({
					value: e,
					label: s(`modes.${e}`)
				}))
			},
			graceValue: {
				type: "number",
				label: s("fields.grace"),
				description: s("form.hints.grace"),
				defaultValue: 3
			},
			graceUnit: {
				type: "select",
				label: s("form.unit"),
				defaultValue: "days",
				options: v
			},
			warningEnabled: {
				type: "switch",
				label: s("form.warningEnabled")
			},
			warningPreset: {
				type: "select",
				label: s("fields.warningSchedule"),
				defaultValue: "thursday",
				options: y(K)
			},
			warningCustom: {
				type: "text",
				label: s("form.cron"),
				placeholder: "0 3 * * 4",
				description: s("form.hints.cron")
			},
			warningOwnPeriod: {
				type: "switch",
				label: s("form.warningOwnPeriod")
			},
			...be("warningPeriod", s),
			sanctionKind: {
				type: "radio",
				label: s("fields.sanction"),
				defaultValue: "remove",
				options: pe.map((e) => ({
					value: e,
					label: s(`sanctions.${e}`)
				}))
			},
			suspendValue: {
				type: "number",
				label: s("form.suspendFor"),
				description: s("form.hints.suspend"),
				defaultValue: 7
			},
			suspendUnit: {
				type: "select",
				label: s("form.unit"),
				defaultValue: "days",
				options: v
			},
			anchorPolicy: {
				type: "select",
				label: s("fields.anchorPolicy"),
				description: s("form.hints.anchorPolicy"),
				defaultValue: "write_once",
				options: me.map((e) => ({
					value: e,
					label: s(`anchorPolicies.${e}`)
				}))
			},
			settlingValue: {
				type: "number",
				label: s("fields.settling"),
				description: s("form.hints.settling"),
				defaultValue: 0
			},
			settlingUnit: {
				type: "select",
				label: s("form.unit"),
				defaultValue: "days",
				options: v
			},
			missingAnchor: {
				type: "select",
				label: s("fields.missingAnchor"),
				defaultValue: "skip",
				options: he.map((e) => ({
					value: e,
					label: s(`missingAnchor.${e}`)
				}))
			},
			minCoveragePercent: {
				type: "number",
				label: s("form.minCoveragePercent"),
				description: s("form.hints.minCoverage"),
				defaultValue: 0
			},
			minCohort: {
				type: "number",
				label: s("fields.minCohort"),
				description: s("form.hints.minCohort"),
				defaultValue: 0
			},
			maxPerRun: {
				type: "number",
				label: s("fields.maxPerRun"),
				description: s("form.hints.maxPerRun"),
				defaultValue: 0
			}
		}, e ? Ne(e) : {}),
		submitLabel: i,
		fieldMap: ke,
		onSubmit: async (e) => {
			let t = je(e);
			if (_.current === "save") return o(t);
			let n = await a(t);
			u({
				report: n,
				checkedAt: (/* @__PURE__ */ new Date()).toISOString()
			});
		}
	}), x = async () => {
		_.current = "check", f(!0);
		try {
			await b.api.handleSubmit();
		} finally {
			_.current = "save", f(!1);
		}
	}, S = J(b.api, "metric"), C = J(b.api, "periodModel"), w = J(b.api, "schedulePreset"), T = J(b.api, "mode"), E = J(b.api, "warningEnabled") === !0, D = J(b.api, "warningPreset"), O = J(b.api, "warningOwnPeriod") === !0, k = J(b.api, "warningPeriodModel"), ee = J(b.api, "sanctionKind"), A = b.Field;
	return /* @__PURE__ */ g(b.Form, {
		className: "flex max-w-3xl flex-col gap-6",
		children: [
			r,
			/* @__PURE__ */ g(Y, {
				title: s("view.general"),
				children: [
					/* @__PURE__ */ h(A, {
						name: "instanceId",
						isDisabled: e !== void 0
					}),
					/* @__PURE__ */ h(A, { name: "name" }),
					/* @__PURE__ */ h(A, { name: "priority" })
				]
			}),
			/* @__PURE__ */ g(Y, {
				title: s("form.sections.measure"),
				hint: s("form.hints.measure"),
				children: [
					/* @__PURE__ */ h(A, { name: "metric" }),
					/* @__PURE__ */ h("div", {
						className: "grid gap-4 sm:grid-cols-2",
						children: S !== "trade_recency" && /* @__PURE__ */ h(A, {
							name: "threshold",
							label: S === "balance" ? s("form.thresholdUsd") : void 0
						})
					}),
					S !== "balance" && /* @__PURE__ */ h(A, { name: "instruments" })
				]
			}),
			/* @__PURE__ */ h(Y, {
				title: s("fields.period"),
				hint: s(`form.hints.periodModels.${C}`),
				children: /* @__PURE__ */ h(Oe, {
					Field: A,
					model: C,
					prefix: "period"
				})
			}),
			/* @__PURE__ */ g(Y, {
				title: s("fields.schedule"),
				children: [/* @__PURE__ */ h(A, { name: "schedulePreset" }), w === W && /* @__PURE__ */ h(A, { name: "scheduleCustom" })]
			}),
			/* @__PURE__ */ g(Y, {
				title: s("view.response"),
				children: [
					/* @__PURE__ */ h(A, { name: "mode" }),
					T === "with_warning" && /* @__PURE__ */ g(m, { children: [
						/* @__PURE__ */ g("div", {
							className: "grid gap-4 sm:grid-cols-2",
							children: [/* @__PURE__ */ h(A, { name: "graceValue" }), /* @__PURE__ */ h(A, { name: "graceUnit" })]
						}),
						/* @__PURE__ */ h(A, { name: "warningEnabled" }),
						E && /* @__PURE__ */ g("div", {
							className: "flex flex-col gap-4 rounded-lg border border-borderSecondary p-4",
							children: [
								/* @__PURE__ */ h("p", {
									className: "text-base text-textSecondary",
									children: s("form.hints.warningRun")
								}),
								/* @__PURE__ */ h(A, { name: "warningPreset" }),
								D === W && /* @__PURE__ */ h(A, { name: "warningCustom" }),
								/* @__PURE__ */ h(A, { name: "warningOwnPeriod" }),
								O && /* @__PURE__ */ h(Oe, {
									Field: A,
									model: k,
									prefix: "warningPeriod"
								})
							]
						})
					] }),
					/* @__PURE__ */ h(A, { name: "sanctionKind" }),
					ee === "suspend" && /* @__PURE__ */ g("div", {
						className: "grid gap-4 sm:grid-cols-2",
						children: [/* @__PURE__ */ h(A, { name: "suspendValue" }), /* @__PURE__ */ h(A, { name: "suspendUnit" })]
					})
				]
			}),
			/* @__PURE__ */ g(Y, {
				title: s("view.advanced"),
				hint: s("form.hints.advanced"),
				children: [
					/* @__PURE__ */ h(A, { name: "anchorPolicy" }),
					/* @__PURE__ */ g("div", {
						className: "grid gap-4 sm:grid-cols-2",
						children: [/* @__PURE__ */ h(A, { name: "settlingValue" }), /* @__PURE__ */ h(A, { name: "settlingUnit" })]
					}),
					/* @__PURE__ */ h(A, { name: "missingAnchor" }),
					/* @__PURE__ */ g("div", {
						className: "grid gap-4 sm:grid-cols-3",
						children: [
							/* @__PURE__ */ h(A, { name: "minCoveragePercent" }),
							/* @__PURE__ */ h(A, { name: "minCohort" }),
							/* @__PURE__ */ h(A, { name: "maxPerRun" })
						]
					})
				]
			}),
			/* @__PURE__ */ h(b.ErrorSummary, {}),
			/* @__PURE__ */ g("div", {
				className: "flex gap-3",
				children: [/* @__PURE__ */ h(b.SubmitButton, {}), /* @__PURE__ */ h(n, {
					variant: "secondary",
					iconStart: "play",
					isPending: d,
					onPress: () => void x(),
					children: s("dryRun.run")
				})]
			}),
			l && /* @__PURE__ */ h(Te, {
				report: l.report,
				checkedAt: l.checkedAt,
				onClose: () => u(null)
			})
		]
	});
}
function Y({ title: e, hint: t, children: n }) {
	return /* @__PURE__ */ h(r, {
		title: e,
		description: t,
		children: /* @__PURE__ */ h("div", {
			className: "flex flex-col gap-4",
			children: n
		})
	});
}
//#endregion
//#region src/lib/pages/CreateRetentionRulePage.tsx
function Ie({ backHref: e, getRuleHref: t }) {
	let { t: n } = p(F), r = A(), [i] = j(), a = v(), o = b();
	return /* @__PURE__ */ g(D, { children: [/* @__PURE__ */ h(O, {
		trail: [{
			href: e,
			label: n("view.back")
		}],
		title: n("create.title")
	}), /* @__PURE__ */ h(Fe, {
		instanceId: i.get("instance"),
		submitLabel: n("create.submit"),
		onCheck: (e) => o.mutateAsync({
			id: null,
			rule: e
		}),
		onSubmit: async (e) => {
			let i = await a.mutateAsync(e);
			l.success({ title: n("create.created", { name: i.name }) }), r(t(i.id));
		}
	})] });
}
//#endregion
//#region src/lib/pages/EditRetentionRulePage.tsx
function Le({ backHref: t, getRuleHref: n }) {
	let { t: r } = p(F), { id: i = "" } = te(), a = A(), o = S(i), s = E(), c = b(), u = (x().data ?? []).find((e) => e.ruleId === i)?.pending ?? 0;
	return /* @__PURE__ */ g(D, { children: [
		/* @__PURE__ */ h(O, {
			trail: [{
				href: t,
				label: r("view.back")
			}, {
				href: n(i),
				label: o.data?.name ?? "…"
			}],
			title: r("edit.title")
		}),
		o.isPending && /* @__PURE__ */ h("p", {
			className: "text-base text-textSecondary",
			children: r("view.loading")
		}),
		o.isError && /* @__PURE__ */ h(e, {
			variant: "danger",
			title: r("view.loadFailed"),
			description: P(o.error, r("view.loadFailedDetail")),
			actionLabel: r("view.retry"),
			onAction: () => void o.refetch()
		}),
		o.data && /* @__PURE__ */ h(Fe, {
			initial: o.data,
			submitLabel: r("edit.submit"),
			onCheck: (e) => c.mutateAsync({
				id: i,
				rule: e
			}),
			notice: /* @__PURE__ */ h(e, {
				variant: u > 0 ? "warning" : "info",
				title: u > 0 ? r("edit.notice.pending", { count: u }) : r("edit.notice.title"),
				description: r("edit.notice.effect")
			}),
			onSubmit: async (e) => {
				let t = await s.mutateAsync({
					id: i,
					rule: e
				});
				l.success({ title: r("edit.done", { name: t.name }) }), a(n(t.id));
			}
		})
	] });
}
//#endregion
//#region src/lib/components/DeleteRetentionRuleDialog.tsx
function Re({ rule: e, onClose: t, onDeleted: n }) {
	let { t: r } = p(F), i = y(), a = async () => {
		try {
			await i.mutateAsync(e.id), l.success({ title: r("delete.done", { name: e.name }) }), n();
		} catch (t) {
			l.danger({
				title: r("delete.failed", { name: e.name }),
				description: P(t, r("delete.failedFallback"))
			});
		}
	};
	return /* @__PURE__ */ h(se, {
		open: !0,
		onOpenChange: (e) => !e && t(),
		title: r("delete.title", { name: e.name }),
		description: r("delete.description"),
		confirmLabel: r("delete.confirm"),
		cancelLabel: r("delete.cancel"),
		onConfirm: () => void a()
	});
}
//#endregion
//#region src/lib/components/RuleRuns.tsx
var ze = {
	completed: "success",
	aborted: "danger",
	running: "info"
};
function Be({ ruleId: e, onOpenRun: n }) {
	let { t: r } = p(F), i = (e, t, n) => ({
		id: e,
		label: t,
		align: "end",
		width: 110,
		cell: (e) => n(e)
	}), a = [
		{
			id: "fired_at",
			label: r("runs.columns.firedAt"),
			isRowHeader: !0,
			isSortable: !0,
			cell: (e) => /* @__PURE__ */ g("div", {
				className: "flex flex-col",
				children: [/* @__PURE__ */ h("span", { children: u(e.firedAt) }), e.abortReason && /* @__PURE__ */ h("span", {
					className: "text-sm text-textSecondary",
					children: e.abortReason
				})]
			})
		},
		{
			id: "stage",
			label: r("runs.columns.stage"),
			width: 110,
			cell: (e) => r(`runs.stages.${e.stage}`)
		},
		{
			id: "status",
			label: r("runs.columns.status"),
			width: 130,
			skeleton: "pill",
			cell: (e) => /* @__PURE__ */ h(t, {
				size: "sm",
				variant: ze[e.status],
				children: r(`runs.statuses.${e.status}`)
			})
		},
		i("cohort", r("runs.columns.cohort"), (e) => e.cohort),
		i("measured", r("runs.columns.measured"), (e) => e.measured),
		i("violations", r("runs.columns.violations"), (e) => e.violations),
		i("applied", r("runs.columns.applied"), (e) => e.applied)
	], o = ce({
		"aria-label": r("runs.label"),
		columns: a,
		defaultSort: {
			by: "fired_at",
			order: "desc"
		},
		getRowKey: (e) => e.id,
		onRowAction: n,
		pageSize: 20
	}), s = w(e, o.requestParams);
	return /* @__PURE__ */ h(o.Frame, { children: /* @__PURE__ */ h(o.Table, {
		query: s,
		emptyState: {
			icon: "history",
			title: r("runs.none")
		}
	}) });
}
//#endregion
//#region src/lib/describe.ts
function X(e) {
	let t = [...I].reverse().find((t) => e >= L[t] && e % L[t] === 0);
	return t ? le({ [t]: e / L[t] }) : le({ seconds: e }, { zero: !0 });
}
function Ve(e, t) {
	let n = e.instruments?.length ? t("describe.onInstruments", { instruments: e.instruments.join(", ") }) : "";
	switch (e.metric) {
		case "balance": return t("describe.balance", {
			threshold: e.threshold,
			currency: "USD"
		});
		case "trade_recency": return t("describe.tradeRecency") + n;
		case "trade_count": return t("describe.tradeCount", { threshold: e.threshold }) + n;
		case "trade_volume": return t("describe.tradeVolume", { threshold: e.threshold }) + n;
		default: {
			let t = e.metric;
			throw Error(`Unsupported metric ${String(t)}`);
		}
	}
}
function Z(e, t) {
	switch (e.model) {
		case "sliding": return t("describe.sliding", { length: X(e.lengthSeconds) });
		case "calendar": return t(`describe.calendar.${e.alignTo || "week"}`);
		case "cycle": return t("describe.cycle", {
			days: e.lengthSeconds / L.days,
			day: e.duePosition
		});
		default: {
			let t = e.model;
			throw Error(`Unsupported period model ${String(t)}`);
		}
	}
}
function He(e, t) {
	return e.sanction.kind === "suspend" ? t("describe.suspend", { duration: X(e.sanction.durationSeconds) }) : t(`sanctions.${e.sanction.kind}`);
}
//#endregion
//#region src/lib/pages/RetentionRulePage.tsx
var Q = "overview", Ue = "runs";
function We({ backHref: t, getEditHref: i, getInstanceHref: a, getRuleHref: o }) {
	let { t: l } = p(F), { id: d = "" } = te(), f = S(d), _ = A(), [v, y] = N(!1), [b, C] = N(null), w = (x().data ?? []).filter((e) => e.ruleId === d), [T] = j(), { pathname: E } = ee(), k = T.get("tab") ?? Q, M = (e) => e === Q ? E : `${E}?tab=${e}`;
	return /* @__PURE__ */ g(D, { children: [
		/* @__PURE__ */ h(O, {
			trail: [{
				href: t,
				label: l("view.back")
			}],
			title: f.data?.name ?? "…",
			actions: f.data && /* @__PURE__ */ g(m, { children: [
				/* @__PURE__ */ h(Ge, { rule: f.data }),
				/* @__PURE__ */ h(n, {
					variant: "secondary",
					iconStart: "pencil",
					onPress: () => void _(i(d)),
					children: l("edit.open")
				}),
				/* @__PURE__ */ h(n, {
					variant: "destructive",
					iconStart: "trash-2",
					onPress: () => y(!0),
					children: l("delete.open")
				})
			] })
		}),
		f.isPending && /* @__PURE__ */ h("p", {
			className: "text-base text-textSecondary",
			children: l("view.loading")
		}),
		f.isError && /* @__PURE__ */ h(e, {
			variant: "danger",
			title: l("view.loadFailed"),
			description: P(f.error, l("view.loadFailedDetail")),
			actionLabel: l("view.retry"),
			onAction: () => void f.refetch()
		}),
		f.data && /* @__PURE__ */ g(m, { children: [
			/* @__PURE__ */ h(s, {
				"aria-label": l("tabs.label"),
				selectedKey: k,
				keyboardActivation: "manual",
				children: [Q, Ue].map((e) => /* @__PURE__ */ h(c, {
					id: e,
					href: M(e),
					children: l(`tabs.${e}`)
				}, e))
			}),
			k === Q && /* @__PURE__ */ g("div", {
				className: "flex flex-col gap-6",
				children: [/* @__PURE__ */ h(ve, { items: w }), /* @__PURE__ */ h(Ke, {
					rule: f.data,
					getInstanceHref: a
				})]
			}),
			k === Ue && /* @__PURE__ */ g("div", {
				className: "flex flex-col gap-4",
				children: [
					/* @__PURE__ */ h("p", {
						className: "text-base text-textSecondary",
						children: l("runs.hint")
					}),
					/* @__PURE__ */ h(Be, {
						ruleId: f.data.id,
						onOpenRun: C
					}),
					b && /* @__PURE__ */ h(r, {
						title: l("runs.decisionsOf", { firedAt: u(b.firedAt) }),
						action: /* @__PURE__ */ h(n, {
							variant: "secondary",
							size: "sm",
							iconStart: "x",
							onPress: () => C(null),
							children: l("runs.closeDecisions")
						}),
						children: /* @__PURE__ */ h(oe, {
							scope: { runId: b.id },
							getRuleHref: o
						}, b.id)
					})
				]
			})
		] }),
		v && f.data && /* @__PURE__ */ h(Re, {
			rule: f.data,
			onClose: () => y(!1),
			onDeleted: () => void _(t, { replace: !0 })
		})
	] });
}
function Ge({ rule: e }) {
	let { t } = p(F), n = T(), r = async (r) => {
		try {
			await n.mutateAsync({
				id: e.id,
				enabled: r
			}), l.success({ title: t(r ? "view.enabledDone" : "view.disabledDone", { name: e.name }) });
		} catch (e) {
			l.danger({
				title: t("view.toggleFailed"),
				description: P(e, t("view.loadFailedDetail"))
			});
		}
	};
	return /* @__PURE__ */ h(o, {
		isSelected: e.enabled,
		isDisabled: n.isPending,
		onChange: (e) => void r(e),
		children: t(e.enabled ? "status.enabled" : "status.disabled")
	});
}
function $({ title: e, items: t }) {
	return /* @__PURE__ */ h(r, {
		title: e,
		children: /* @__PURE__ */ h(k, { items: t })
	});
}
function Ke({ rule: t, getInstanceHref: n }) {
	let { t: r } = p(F), i = M().data?.find((e) => e.id === t.instanceId), o = r("view.none"), s = (e) => /* @__PURE__ */ h("code", {
		className: "font-mono",
		children: e
	});
	return /* @__PURE__ */ g(m, { children: [!t.enabled && /* @__PURE__ */ h(e, {
		variant: "warning",
		description: r("view.disabledHint")
	}), /* @__PURE__ */ g("div", {
		className: "grid items-start gap-6 lg:grid-cols-2",
		children: [
			/* @__PURE__ */ h($, {
				title: r("view.general"),
				items: [{
					label: r("fields.instance"),
					value: /* @__PURE__ */ h(a, {
						href: n(t.instanceId),
						variant: "secondary",
						children: i?.name ?? r("unknown")
					})
				}, {
					label: r("fields.priority"),
					value: t.priority
				}]
			}),
			/* @__PURE__ */ h($, {
				title: r("view.condition"),
				items: [
					{
						label: r("fields.measurement"),
						value: Ve(t.measurement, r)
					},
					{
						label: r("fields.period"),
						value: Z(t.period, r)
					},
					{
						label: r("fields.schedule"),
						value: s(t.schedule)
					}
				]
			}),
			/* @__PURE__ */ h($, {
				title: r("view.response"),
				items: [
					{
						label: r("fields.mode"),
						value: r(`modes.${t.mode}`)
					},
					...t.mode === "with_warning" ? [
						{
							label: r("fields.grace"),
							value: X(t.graceSeconds)
						},
						{
							label: r("fields.warningSchedule"),
							value: t.warning.schedule ? s(t.warning.schedule) : r("view.noWarningRun")
						},
						{
							label: r("fields.warningPeriod"),
							value: t.warning.period ? Z(t.warning.period, r) : r("view.samePeriod")
						}
					] : [],
					{
						label: r("fields.sanction"),
						value: He(t, r)
					}
				]
			}),
			/* @__PURE__ */ h($, {
				title: r("view.advanced"),
				items: [
					{
						label: r("fields.anchorPolicy"),
						value: r(`anchorPolicies.${t.anchorPolicy}`)
					},
					{
						label: r("fields.settling"),
						value: t.settlingSeconds ? X(t.settlingSeconds) : o
					},
					{
						label: r("fields.missingAnchor"),
						value: r(`missingAnchor.${t.missingAnchor}`)
					},
					{
						label: r("fields.minCoverage"),
						value: t.minCoverage ? `${Math.round(t.minCoverage * 100)}%` : o
					},
					{
						label: r("fields.minCohort"),
						value: t.minCohort || o
					},
					{
						label: r("fields.maxPerRun"),
						value: t.maxPerRun || r("view.unlimited")
					}
				]
			})
		]
	})] });
}
//#endregion
//#region src/lib/pages/RetentionRulesPage.tsx
function qe({ createHref: e, getInstanceHref: r, getRuleHref: i }) {
	let { t: o } = p(F), s = j(), c = A(), l = M().data ?? [], u = new Map(l.map((e) => [e.id, e.name])), d = () => void c(e), f = x().data ?? [], m = new Map(f.map((e) => [e.ruleId, e])), v = [
		{
			id: "name",
			label: o("columns.name"),
			isRowHeader: !0,
			isSortable: !0,
			width: 220,
			cell: (e) => /* @__PURE__ */ h(a, {
				href: i(e.id),
				children: e.name
			})
		},
		{
			id: "instance",
			label: o("columns.instance"),
			width: 180,
			cell: (e) => /* @__PURE__ */ h(a, {
				href: r(e.instanceId),
				variant: "secondary",
				children: u.get(e.instanceId) ?? o("unknown")
			})
		},
		{
			id: "condition",
			label: o("columns.condition"),
			cell: (e) => /* @__PURE__ */ g("span", {
				className: "text-textSecondary",
				children: [
					Ve(e.measurement, o),
					" · ",
					Z(e.period, o)
				]
			})
		},
		{
			id: "sanction",
			label: o("columns.sanction"),
			width: 180,
			cell: (e) => He(e, o)
		},
		{
			id: "priority",
			label: o("columns.priority"),
			isSortable: !0,
			width: 110,
			align: "end",
			cell: (e) => e.priority
		},
		{
			id: "health",
			label: o("columns.health"),
			width: 200,
			cell: (e) => {
				let t = m.get(e.id);
				return t ? /* @__PURE__ */ h(_e, { items: [t] }) : /* @__PURE__ */ h("span", {
					className: "text-textTertiary",
					children: "—"
				});
			}
		},
		{
			id: "status",
			label: o("columns.status"),
			width: 120,
			skeleton: "pill",
			cell: (e) => /* @__PURE__ */ h(t, {
				size: "sm",
				variant: e.enabled ? "success" : "neutral",
				children: o(e.enabled ? "status.enabled" : "status.disabled")
			})
		}
	], y = ce({
		"aria-label": o("table.label"),
		columns: v,
		defaultSort: {
			by: "name",
			order: "asc"
		},
		getRowKey: (e) => e.id,
		searchParams: s,
		filters: {
			instance: {
				type: "select",
				label: o("filters.instance"),
				defaultValue: _,
				options: [{
					value: _,
					label: o("filters.allInstances")
				}, ...l.map((e) => ({
					value: e.id,
					label: e.name
				}))]
			},
			query: {
				type: "search",
				label: o("filters.search"),
				defaultValue: ""
			}
		}
	}), b = C(y.requestParams, y.filters);
	return /* @__PURE__ */ g(D, { children: [/* @__PURE__ */ h(O, { title: o("title") }), /* @__PURE__ */ g(y.Frame, { children: [/* @__PURE__ */ h(y.Toolbar, { children: /* @__PURE__ */ h(n, {
		iconStart: "plus",
		onPress: d,
		children: o("create.open")
	}) }), /* @__PURE__ */ h(y.Table, {
		query: b,
		emptyState: {
			icon: "shield-check",
			title: o("empty.title"),
			description: o("empty.description"),
			actionLabel: o("create.open"),
			onAction: d
		}
	})] })] });
}
//#endregion
export { Ie as CreateRetentionRulePage, Le as EditRetentionRulePage, F as FEATURE_SPG_RETENTION_RULES_NAMESPACE, ve as HealthAlerts, _e as HealthBadges, We as RetentionRulePage, qe as RetentionRulesPage };
